Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "ThreeDots2213347852",
  {"root":"ThreeDots2213347852--root","icon":"ThreeDots2213347852--icon","actionsMenu":"ThreeDots2213347852--actionsMenu"},
  "",
  8,
  "ThreeDots2213347852"
);

